import './email-subject-control.scss';

import EmailSubjectControl from './EmailSubjectControl';

export default EmailSubjectControl;
